import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import activeScreenReducer from "../activeScreenSlice"
import toastReducer from "../toastSlice"

const activeScreenPersistConfig = {
  key: "activeScreen",
  storage,
  whitelist: [
    "tableFilterState",
    "invoiceTableColumns",
    "invoiceTableHiddenColumns",
    "poLinksTableColumns",
    "poLinksTableHiddenColumns",
  ],
}

const persistedActiveScreenReducer = persistReducer(
  activeScreenPersistConfig,
  activeScreenReducer,
)

export const store = configureStore({
  reducer: {
    activeScreen: persistedActiveScreenReducer,
    toast: toastReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
})

export const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
